import React from "react"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { FormFeedback, Input } from "reactstrap"
import FabricOrderAction from "store/fabric-order-resource/actions"
import ReadOnlyInput from "./ReadOnlyInput"

function SelectFabricNumber(props) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const { validation, edit, detail, detailIndex } = props
  const { setFieldValue, handleBlur, handleChange, values, errors, touched } =
    validation

  const onChange = e => {
    if (e) {
      setFieldValue(`details.${detailIndex}.fabricId`, e.value)
      setFieldValue(`details.${detailIndex}.fabricNumber`, e.number)
      setFieldValue(`details.${detailIndex}.unitPrice`, e.latestUnitPrice)
    } else {
      setFieldValue(`details.${detailIndex}.fabricId`, "")
      setFieldValue(`details.${detailIndex}.fabricNumber`, "")
      setFieldValue(`details.${detailIndex}.unitPrice`, "")
    }
  }

  if (edit || !detail.isIgarashi || detail.activeColumn == 1 || !detail.bunch) {
    return (
      <ReadOnlyInput
        value={detail.fabricNumber}
        name="fabricNumber"
        className="form-control"
        type="text"
        invalid={
          touched?.details && errors?.details
            ? touched?.details[detailIndex]?.fabricNumber &&
              errors?.details[detailIndex]?.fabricNumber
              ? true
              : false
            : false
        }
        touched={touched}
        errors={errors}
        errorMessage="必須項目です。"
      />
    )
  }

  return (
    <>
      <Select
        isLoading={store.fabricOrder.number.loading}
        isDisabled={edit}
        options={store.fabricOrder.number.data.map(i => ({
          value: i.id,
          label: i.number,
          ...i,
        }))}
        defaultValue={{
          value: detail.fabricId,
          label: detail.fabricNumber,
        }}
        value={{
          value: detail.fabricId,
          label: detail.fabricNumber,
        }}
        onChange={onChange}
        isClearable
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />

      <Input
        name="fabricId"
        className="form-control d-none"
        type="text"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.fabricId || ""}
        invalid={
          touched?.details && errors?.details
            ? touched?.details[detailIndex]?.fabricId &&
              errors?.details[detailIndex]?.fabricId
              ? true
              : false
            : false
        }
      />
      {touched?.details && errors?.details ? (
        <FormFeedback type="invalid">
          {errors?.details[detailIndex]?.fabricId}
        </FormFeedback>
      ) : null}
    </>
  )
}

export default SelectFabricNumber
